/** Tracks initial VAT log fetches per connection + mapping set (survives remounts). */
const initialVatLogsRequested = new Set<string>();

const vatLogsBurstAt = new Map<string, number>();

export function buildVatLogsFetchKey(
  connectionId: string,
  mappingIds: string[]
): string {
  const uniqueSorted = [...new Set(mappingIds.filter(Boolean))].sort();
  return `${connectionId}|${uniqueSorted.join(',')}`;
}

export function hasInitialVatLogsBeenRequested(fetchKey: string): boolean {
  return initialVatLogsRequested.has(fetchKey);
}

export function markInitialVatLogsRequested(fetchKey: string): void {
  initialVatLogsRequested.add(fetchKey);
}

/** Short-window dedupe for back-to-back duplicate dispatches (e.g. org + maps settling). */
export function shouldSkipVatLogsBurst(
  fetchKey: string,
  windowMs = 1500
): boolean {
  const now = Date.now();
  const lastAt = vatLogsBurstAt.get(fetchKey);
  if (lastAt != null && now - lastAt < windowMs) return true;
  vatLogsBurstAt.set(fetchKey, now);
  if (vatLogsBurstAt.size > 200) {
    for (const [key, at] of vatLogsBurstAt.entries()) {
      if (now - at > windowMs * 10) vatLogsBurstAt.delete(key);
    }
  }
  return false;
}
